import { normalizeRoleScope, resolveRoleIdFromValue } from '../../../config/rbacConfig';
import { extractScopeSeed } from '../../../utils/scopeFields';

const NATIONAL_ROLE_IDS = new Set(['R01', 'R02', 'R03', 'R06']);
const GEO_REQUIRED_ROLE_IDS = new Set(['R04', 'R05']);

function normalizeRoleId(value) {
  return resolveRoleIdFromValue(value);
}

export function getUserRoleId(user = {}) {
  return normalizeRoleId(
    user.role_id ??
      user.roleId ??
      user.role ??
      user.roles?.[0] ??
      user.role?.id ??
      user.role?.uuid ??
      user.role?.code ??
      user.role?.name ??
      user.role?.label ??
      user.role_code ??
      user.roleCode ??
      user.role_name ??
      user.roleName ??
      user.role_label ??
      user.roleLabel ??
      user.backend_class ??
      user.backendClass ??
      user.roles?.[0]?.id ??
      user.roles?.[0]?.uuid ??
      user.roles?.[0]?.code ??
      user.roles?.[0]?.name ??
      user.roles?.[0]?.label ??
      user.roles?.[0]?.role_id ??
      user.roles?.[0]?.roleId ??
      user.roles?.[0]?.role_code ??
      user.roles?.[0]?.roleCode ??
      null
  );
}

export function resolveUserScope(user = {}) {
  const roleId = getUserRoleId(user);
  const scope = normalizeRoleScope(roleId, extractScopeSeed(user));
  const scopeLevel = String(scope.level ?? '').trim().toLowerCase();

  // Backend scope = the user's state / lga: none → national, state only →
  // State Officer (R04, whole state), state + lga → Field Officer (R05).
  const requiresState = GEO_REQUIRED_ROLE_IDS.has(roleId) || scopeLevel === 'state' || scopeLevel === 'lga';
  const requiresLga = roleId === 'R05' || (roleId !== 'R04' && scopeLevel === 'lga');

  return {
    roleId,
    scope,
    isNationalScope: NATIONAL_ROLE_IDS.has(roleId) || scopeLevel === 'national',
    requiresStateLga: requiresState,
    requiresState,
    requiresLga,
  };
}
